import { useMemo, useState } from 'react';

export const useLayout = () => {
  const [isHeaderHidden, setHeaderHidden] = useState(true);

  return useMemo(
    () => ({
      isHeaderHidden,
      setHeaderHidden,
    }),
    [isHeaderHidden]
  );
};
